export default "__VITE_ASSET__8NDjOkwT__"